import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)
let state = {
  token: '',
  // 当前用户的ID
  contactId: '',
  isLoading: false,
  isDetailLoading: false,
  isMessageLoading: false,
  // 问题详情
  questionDetail: {},
  // 评论列表
  messageDetail: [],
  // 相关问题列表
  relatedQuizDetail: [],
  // 问题列表
  questionPage: [],
  // 当前类型问题总条数
  allQuestionCount: 0,
  // 默认一次返回的问题数量
  pageSize: 20,
  // 分页按钮最大支持数量
  MAX_PAGE_COUNT: 5,
  // 默认最大返回的评论数，或相关问题数
  commentPageSize: 20,
  // 当前问题列表下的分页总数
  pageCount: 1,
  redPoint: {
    hasRedPoint: 0,
    redPointNumber: 0
  },
  redPointTime: null,
  // 预览图片相关
  imgPreviewStartIndex: 0,
  previewImg: {
    needShowImgPreviewCommon: false,
    currImgNeedToPreview: null,
    imgSrcNeedToPreview: []
  },
  aliPlayerUrl: null   //ali播放器路径
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js